<script setup lang="ts">
import Point from '@/models/point';
import PointItem from '@/components/mobile/telegram/selected_point_components/PointItem.vue';

const props = defineProps<{ 
  points: Point[],
  selectedPoint: Point | null
}>();

const emit = defineEmits<{
  (e: 'closeModal'): void,
  (e: 'selectPoint', point: Point): void
}>()

</script>

<template>

  <div class="choose-point-wrapper">
    <div class="head">
      <p class="head__name">{{ props.selectedPoint !== null ? 'Изменить точку' : 'Выберите точку' }}</p>
      <button type="button" class="close-btn">
        <img src="@/assets/desktop/close_cart.svg" class="close-img" @click="emit('closeModal')">
      </button>
    </div>
    <div class="points-wrapper">
      <PointItem v-for="(point, i) in props.points"
        :point="point"
        :selected-point="props.selectedPoint"
        :is-first="i === 0"
        :is-last="i === props.points.length - 1"
        @select-point="emit('selectPoint', $event)"
      />
    </div>
  </div>

</template>

<style scoped>

.points-wrapper {
  width: 100%;
  margin-top: 20px;
}

.close-img {
  width: 30px;
}

.close-btn {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  background: none;
  font-family: inherit;
  -webkit-tap-highlight-color: transparent;
}

.head {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.choose-point-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: white;
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
  z-index: 4;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
}

</style>